/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useApi from "../../../../utils/api-manager/Helper/useApi";

const SettingTableCheque = ({
  apiUrl,
  columns,
  showAction,
  showFooter,
  onEdit,
  onDelete,
  showExport,
  onPrintAgain,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { _Get } = useApi();

  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    currentPage: 1,
    totalPages: 1,
  });
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage] = useState(10); // Fixed to match Django's pagination

  useEffect(() => {
    fetchData(`${apiUrl}?page=1`);
  }, [apiUrl]);

  const fetchData = async (url) => {
    try {
      setLoading(true);
      const response = await _Get(url);
      const json = await response;

      // Calculate total pages
      const totalPages = Math.ceil(json.count / rowsPerPage);

      // Extract current page from URL or default to 1
      const currentPage = parseInt(url.split("page=")[1]) || 1;

      setData(json.results);
      setPagination({
        count: json.count,
        next: json.next,
        previous: json.previous,
        currentPage: currentPage,
        totalPages: totalPages,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    fetchData(`${apiUrl}?page=${pageNumber}`);
  };

  const formatDate = (date) => {
    // If the field is 'created_by', format as a date string (e.g., YYYY-MM-DD)
    if (date instanceof Date || !isNaN(Date.parse(date))) {
      return new Date(date).toLocaleDateString('en-GB'); // Change locale as per your needs
    }
    return date; // For non-date fields, return the value as it is
  };
  
  const getPageNumbers = () => {
    const pageNumbers = [];
    const { currentPage, totalPages } = pagination;

    // Always show first page
    pageNumbers.push(1);

    // Calculate range of pages to show around current page
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    // Add ellipsis after first page if needed
    if (start > 2) {
      pageNumbers.push("...");
    }

    // Add pages around current page
    for (let i = start; i <= end; i++) {
      pageNumbers.push(i);
    }

    // Add ellipsis before last page if needed
    if (end < totalPages - 1) {
      pageNumbers.push("...");
    }

    // Always show last page if there is more than one page
    if (totalPages > 1) {
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  }, [data, sortConfig]);

  const filteredData = React.useMemo(() => {
    if (!searchTerm) return sortedData;
    return sortedData.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [sortedData, searchTerm]);

  const downloadCSV = () => {
    const headers = columns.map((col) => col.header).join(",") + "\n";
    const rows = data
      .map((row) =>
        columns.map((col) => String(row[col.field] || "")).join(",")
      )
      .join("\n");

    const csvContent = headers + rows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const statusStyles = {
    enable: {
      backgroundColor: "#6CBE1C",
      color: "#fff",
      borderRadius: "30px",
      padding: "5px 10px",
    },
    disable: {
      backgroundColor: "#F6F6F6",
      color: "#fff",
      borderRadius: "30px",
      padding: "5px 10px",
    },
    draft: {
      backgroundColor: "#D1D1EF",
      color: "#fff",
      borderRadius: "30px",
      padding: "5px 10px",
    },
    unpaid: {
      backgroundColor: "#EF3E49",
      color: "#fff",
      borderRadius: "30px",
      padding: "5px 10px",
    },
    paid: {
      backgroundColor: "#5856AC",
      color: "#fff",
      borderRadius: "30px",
      padding: "5px 10px",
    },
  };

  return (
    <div className="data-table-container">
      <div className="d-flex mb-3 mt-3">
        <div className="expense-searchcontainerstart d-flex">
          <div className="search-container">
          <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search"
              style={{ height: "45px", backgroundColor: "#fff", border: '1px solid #DBDBDB', boxShadow: "0px 0px 10px rgba(187, 187, 187, 0.25)" }}
            />
            <svg
              className="search-container-icon"
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5416 19.2497C15.3511 19.2497 19.2499 15.3508 19.2499 10.5413C19.2499 5.73186 15.3511 1.83301 10.5416 1.83301C5.73211 1.83301 1.83325 5.73186 1.83325 10.5413C1.83325 15.3508 5.73211 19.2497 10.5416 19.2497Z"
                stroke="#292D32"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.1666 20.1663L18.3333 18.333"
                stroke="#292D32"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          {showExport && (
            <button
              type="button"
              className="btn btn-outline-dark custbtn ml-2"
              style={{ borderRadius: "10px", border: "1px solid #f4f4f4" }}
              onClick={downloadCSV}
            >
              <svg
                className="mr-2"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.98975 4.87312L8.90975 2.95312L10.8297 4.87312"
                  stroke="#4A5546"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.91016 10.6353V3.00781"
                  stroke="#4A5546"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M3 9C3 12.315 5.25 15 9 15C12.75 15 15 12.315 15 9"
                  stroke="#4A5546"
                  strokeWidth="1.5"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              &nbsp;
              Export To Excel
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <>
          <table
            className="data-table custom-table"
            style={{
              borderRadius: "20px 20px 0 0",
              border: "1px solid #EBEAF2",
              borderCollapse: "separate",
              borderSpacing: 0,
              overflow: "hidden",
            }}
          >
            <thead className="table-header">
              <tr>
                <th scope="col" className="no-column">
                  No
                </th>
                {columns.map((col, index) => (
                  <th
                    key={index}
                    scope="col"
                    onClick={() => handleSort(col.field)}
                    className="cursor-pointer"
                  >
                    {col.header}
                    {sortConfig.key === col.field && (
                      <svg
                        width="8"
                        height="4"
                        viewBox="0 0 8 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="ml-1 inline"
                      >
                        <path
                          d={
                            sortConfig.direction === "ascending"
                              ? "M0 4L4 0L8 4H0Z"
                              : "M0 0L4 4L8 0H0Z"
                          }
                          fill="#000000"
                        />
                      </svg>
                    )}
                  </th>
                ))}
                {showAction && (
                  <th scope="col" className="action-column">
                    Action
                  </th>
                )}
              </tr>
            </thead>
            <tbody className="table-body">
  {filteredData.length === 0 ? (
    <tr>
      <td colSpan={columns.length + (showAction ? 2 : 1)} className="text-center py-4 text-2xl font-semibold">
        No data found
      </td>
    </tr>
  ) : (
    filteredData.map((item, index) => (
      <tr key={item.id}>
        <td>{index + 1}</td>
        {columns.map((col, colIndex) => (
          <td key={colIndex}>
            {col.field === "status" ? (
              <div style={statusStyles[item[col.field]]}>
                {typeof item[col.field] === "string"
                  ? item[col.field].charAt(0).toUpperCase() + item[col.field].slice(1)
                  : "-"}
              </div>
            ) : col.field === "created_at" ? (
              // Format the 'created_by' field as a date
              formatDate(item[col.field])
            ) : item[col.field] !== undefined && item[col.field] !== null ? (
              Array.isArray(item[col.field]) ? (
                item[col.field].join(", ")
              ) : (
                item[col.field]
              )
            ) : (
              "-"
            )}
          </td>
        ))}
        {showAction && (
          <td className="action-column">
            {typeof onEdit === 'function' && (
            <button className="action-button mr-2" onClick={() => onEdit(item)}>
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8067 4.695C14.0667 4.435 14.0667 4.00167 13.8067 3.755L12.2467 2.195C12 1.935 11.5667 1.935 11.3067 2.195L10.08 3.415L12.58 5.915M2 11.5017V14.0017H4.5L11.8733 6.62167L9.37333 4.12167L2 11.5017Z"
                  fill="#000000"
                />
              </svg>
            </button>
            )}
            {typeof onPrintAgain === 'function' && (
              <button className="action-button mr-2" onClick={() => onPrintAgain(item)}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 12V10H12V12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12Z" fill="#000000"/>
                  <path d="M12 8V6C12 5.44772 11.5523 5 11 5H5C4.44772 5 4 5.44772 4 6V8" stroke="#000000" strokeWidth="1.5"/>
                  <rect x="2" y="8" width="12" height="4" rx="2" stroke="#000000" strokeWidth="1.5"/>
                </svg>
              </button>
            )}
            {typeof onDelete === 'function' && (
            <button className="action-button" onClick={() => onDelete(item.id)}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.00016 12.6667C4.00016 13.4 4.60016 14 5.3335 14H10.6668C11.4002 14 12.0002 13.4 12.0002 12.6667V6C12.0002 5.26667 11.4002 4.66667 10.6668 4.66667H5.3335C4.60016 4.66667 4.00016 5.26667 4.00016 6V12.6667ZM12.0002 2.66667H10.3335L9.86016 2.19333C9.74016 2.07333 9.56683 2 9.3935 2H6.60683C6.4335 2 6.26016 2.07333 6.14016 2.19333L5.66683 2.66667H4.00016C3.6335 2.66667 3.3335 2.96667 3.3335 3.33333C3.3335 3.7 3.6335 4 4.00016 4H12.0002C12.3668 4 12.6668 3.7 12.6668 3.33333C12.6668 2.96667 12.3668 2.66667 12.0002 2.66667Z"
                  fill="#000000"
                />
              </svg>
            </button>
            )}
          </td>
        )}
      </tr>
    ))
  )}
</tbody>

          </table>
          {showFooter && (

             <ul className="pagination">

                {getPageNumbers().map((pageNum, index) => (
                  <React.Fragment key={index}>
                    {pageNum === "..." ? (
                      <span className="px-2">...</span>
                    ) : (
                      <li
                        className={`page-item ${
                          pagination.currentPage === pageNum
                            ? "active"
                            : "pgbtn"
                        } mx-1`}
                        onClick={() => handlePageChange(pageNum)}
                        >
                        <a className="page-link focus:outline-none" href="#">
                          {pageNum}
                        </a>{" "}
                      </li>
                    )}
                  </React.Fragment>
                ))}
             </ul>
          )}
          &nbsp;&nbsp;
          <span className="ml-4">
            Showing {Math.min(rowsPerPage, data.length)} of {pagination.count}{" "}
            entries (Page {pagination.currentPage} of {pagination.totalPages})
          </span>
        </>
      )}
    </div>
  );
};

export default SettingTableCheque;
